export const noCache = (url: string): string => {
  const timestamp = new Date().getTime() // Gera um timestamp atual
  const separator = url.includes('?') ? '&' : '?' // Verifica se a URL já possui parâmetros de query
  return `${url}${separator}t=${timestamp}` // Adiciona o timestamp como um parâmetro de query
}